import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { faCirclePlus } from '@fortawesome/pro-solid-svg-icons';

import theme from '~/theme/';

import QuestionLibraryButton from './QuestionLibraryButton';

type AddIconButtonProps = {
  handleClick: (...args: any[]) => any;
  label: string;
  testId?: string;
  isDisabled?: boolean;
  marginLeft?: string;
  sx?: Record<string, string>;
  variant?: string;
  iconVariant?: 'solid' | 'outline';
};

export default function AddIconButton({
  handleClick,
  label = 'Add',
  testId = 'add-icon-button',
  isDisabled = false,
  variant = 'outline',
  iconVariant = 'outline',
  sx,
}: Readonly<AddIconButtonProps>) {
  let icon = faPlus;

  if (iconVariant === 'solid') {
    icon = faCirclePlus;
  }

  return (
    <QuestionLibraryButton
      handleClick={() => handleClick()}
      testId={testId}
      isDisabled={isDisabled}
      icon={icon}
      fontColor={theme.colors?.blue[600]}
      label={label}
      variant={variant}
      sx={sx}
    />
  );
}
